import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import Can from "../../helpers/Can";
import Forbidden from "../../pages/errors/Forbidden";

const PermissionGuard = ({ permission, children }) => {
  const { user } = useSelector((state) => state.profile);
  
  // Show loading spinner while user data is being fetched
  if (user.loading || !user.info.id) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  return Can(permission) ? children : <Forbidden />;
};

export default PermissionGuard;
